<template>
    <el-dialog title="提示" :visible.sync="dialogVisibles" :before-close="handleClose">
        <div v-loading="questionList.length == 0">
            <div v-for="item, index in questionList" :key="item.id">
                <div style="margin:10px 0;display: flex; align-items: center;">
                    <el-tag>问题{{ index + 1 }}</el-tag>
                    <div style="flex:1;margin-left:10px;">{{ item.question }}</div>
                </div>
                <el-input type="textarea" :rows="3" placeholder="请输入答案" v-model="item.answer">
                </el-input>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibles = false">取 消</el-button>
            <el-button type="primary" @click="handleOk()">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { getQuestionList } from '../../../restful/api'
export default {
    name: "Beginindex",
    props: ["dialogVisible", "id"],
    data() {
        return {
            questionList: [],
            num: 0,
            timer: null
        }
    },
    computed: {
        dialogVisibles: {
            get() {
                return this.dialogVisible
            },
            set(val) {
                this.$emit("updatedialogVisibles", val)
            }
        }
    },
    created() {
        this.getQuestionList()
    },
    methods: {
        getQuestionList() {
            this.$http.getQuestionList(this.id).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.questionList = res.data
                    this.timesAll()
                }
            })
        },
        timesAll() {
            this.timer = setInterval(() => {
                this.num++
            }, 1000)
        },
        handleClose() {
            this.dialogVisibles = false
            console.log("执行");
        },
        handleOk() {
            const params = {
                answer: JSON.stringify(this.questionList),
                assignment_id: this.id,
                total_time: this.num
            }
            console.log(params);
            // return
            this.$http.uploadQuestionList(params).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.dialogVisibles = false;
                    this.$message({
                        message: '提交成功',
                        type: 'success',
                    })
                }
            })
        }
    },
    destroyed() {
        clearInterval(this.timer)
    }
}
</script>

<style lang="less" scoped></style>


// WEBPACK FOOTER //
// src/components/User/homeWorkModal/Beginindex.vue